import React, { useEffect, useState, useRef } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row, Button } from 'react-bootstrap'
import { IoAddCircleOutline } from 'react-icons/io5'

import useFetchData from 'Shared/Hooks/useFetchData'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'
import EquipmentForm from './Forms/EquipmentForm'
import PopupModal from 'Shared/Components/PopupModal'

const AssetList = () => {
  const { role, projectInfo, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()
  const navigate = useNavigate()
  const {  } = useOutletContext()

  const [equipments, setEquipments] = useState([])

  const [isformOpen, setFormOpen] = useState(false)

  const tableRef = useRef()

  const getEquipmentStatus = (status) => {
    switch (status) {
      case 0:
        return t("assetsTracking_active")
      case -1:
        return t("assetsTracking_closeToExpiry")
      case -2:
        return t("assetsTracking_expired")
    }
  }

  const getEquipments = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/assets_tracking/list`,
      params: {
        "offset": (tableRef.current.getState()["page"]-1)*tableRef.current.getState()["itemsPerPage"],
        "limit": tableRef.current.getState()["itemsPerPage"],
      },
      returnType: "json"
    })

    body && setEquipments({
      "count": Math.ceil(body["count"]/tableRef.current.getState()["itemsPerPage"]),
      "data": body["data"].map((i) => ({
        "assets_id": i["assets_id"],
        "equipment_name": i["equipment_name"],
        "equipment_description": i["equipment_description"],
        "equipment_type": i["equipment_type"],
        "manufacturer": i["manufacturer"],
        "model": i["model"],
        "remark": i["remark"],
        "due_date": i["due_date"] ? <div>{i["due_date"]}</div> : null,
        "status": i["status"] === 0 ? t("assetsTracking_equipmentInactive") : (i["certificate_status"] != null) ? <div className={i["certificate_status"] !== 0 ? "text-alert" : "text-normal"}>{getEquipmentStatus(i["certificate_status"])}</div> : null
      }))
    })
  }

  const loadData = async () => {
    tableRef.current.setTableLoading(true)

    await getEquipments(false)

    tableRef.current.setTableLoading(false)
  }
  
  useEffect(() => {
    const init = async () => {
      await Promise.all([
        getEquipments()
      ])

      setPageLoading(false)
    }

    init()
  }, [])

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={equipments["data"]} count={equipments["count"]} loadData={() => loadData()} ref={tableRef}
              onRowClick={(["admin"].includes(role) && projectInfo["info"]["assets_tracking"]["supplier"] === "") ? function(e, row) { navigate(`./${row["assets_id"]}`) } : null}
              appActions={() => { return [
                (["pm", "admin"].includes(role) && projectInfo["info"]["assets_tracking"]["supplier"] === "") && {icon: <IoAddCircleOutline size={20}/>, text: t("general_add"), onClick: function() { setFormOpen(true) }}
              ]}}
              columns={{
                "equipment_name": { "label": t("assetsTracking_equipmentName"), "sorting": false, "nowrap": true },
                "equipment_description": { "label": t("assetsTracking_equipmentDescription"), "sorting": false, "nowrap": true },
                "equipment_type": { "label": t("assetsTracking_equipmentType"), "sorting": false, "nowrap": true },
                "manufacturer": { "label": t("assetsTracking_manufacturer"), "sorting": false, "nowrap": true },
                "model": { "label": t("assetsTracking_model"), "sorting": false, "nowrap": true },
                "remark": { "label": t("assetsTracking_remark"), "sorting": false, "nowrap": false },
                "due_date": { "label": t("assetsTracking_dueDate"), "sorting": false, "nowrap": true },
                "status": { "label": t("assetsTracking_status"), "sorting": false, "nowrap": true },
              }}
            />
          </Paper>
        </Col>
      </Row>
    </Container>

    <PopupModal isOpen={isformOpen} close toggle={() => setFormOpen(false)} width="80%" height="80%">
      <EquipmentForm mode="create" initialState={{}} reload={loadData}/>
    </PopupModal>
  </>)
}

export default AssetList
